import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import {connect} from "react-redux";

const CarrouselMaterial = ({data, dark}) => {
    return <div className="m-auto bg-success">
        <Carousel centerMode
                  centerSlidePercentage={window.innerWidth < 768 ? 100 : 50}
                  emulateTouch
                  showThumbs={false}
                  dynamicHeight
                  showStatus={false}
                  infiniteLoop
                  autoPlay
                  swippeable>
            {data.map(({source}, index) => <div style={{backgroundColor: dark ? "#212121" : "#EEEEEE"}} key={index}><iframe width="400" height="300" src={source}/></div>)}
        </Carousel>
    </div>
}

CarrouselMaterial.defaultProps = {
    "data": [
        {"source": "https://www.youtube.com/embed/CplwgrIjD3o"},
        {"source": "https://www.youtube.com/embed/xSnWkPhICt4"},
        {"source": "https://www.youtube.com/embed/YRDYsFqKmcw"}
    ]
}

const mapStateToProps = state => ({
    dark : state.dark
});


export default connect(mapStateToProps, {})(CarrouselMaterial)









/*
import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import MobileStepper from '@material-ui/core/MobileStepper';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import {lgCarrousselFeeder} from '../../helpers'

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const tutorialSteps = [
    {
        label: 'San Francisco – Oakland Bay Bridge, United States',
        imgPath: 'https://images.unsplash.com/photo-1537944434965-cf4679d1a598?auto=format&fit=crop&w=400&h=250&q=60',
        source: "https://www.youtube.com/embed/GJUD7QE7gkY"
    },
    {
        label: 'Bird',
        imgPath: 'https://images.unsplash.com/photo-1538032746644-0212e812a9e7?auto=format&fit=crop&w=400&h=250&q=60',
        source: "https://www.youtube.com/embed/GJUD7QE7gkY"
    },
    {
        label: 'Bali, Indonesia',
        imgPath: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=400&h=250&q=80',
        source: "https://www.youtube.com/embed/GJUD7QE7gkY"
    },
    {
        label: 'NeONBRAND Digital Marketing, Las Vegas, United States',
        imgPath: 'https://images.unsplash.com/photo-1518732714860-b62714ce0c59?auto=format&fit=crop&w=400&h=250&q=60',
        source: "https://www.youtube.com/embed/GJUD7QE7gkY"
    },
    {
        label: 'Goč, Serbia',
        imgPath: 'https://images.unsplash.com/photo-1512341689857-198e7e2f3ca8?auto=format&fit=crop&w=400&h=250&q=60',
        source: "https://www.youtube.com/embed/GJUD7QE7gkY"
    },
];

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        height: 50,
        paddingLeft: theme.spacing(4),
        backgroundColor: theme.palette.background.default,
    },
    img: {
        height: 255,
        display: 'block',
        maxWidth: 400,
        overflow: 'hidden',
        width: '100%',
    },
}));

function CarrouselMaterial() {
    const classes = useStyles();
    const theme = useTheme();
    const [activeStep, setActiveStep] = React.useState(0);
    const maxSteps = tutorialSteps.length;

    const handleNext = () => {
        setActiveStep(prevActiveStep => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep(prevActiveStep => prevActiveStep - 1);
    };

    const handleStepChange = step => {
        setActiveStep(step);
    };
    return (
        <div className={classes.root}>
            <AutoPlaySwipeableViews
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={activeStep}
                onChangeIndex={handleStepChange}
                enableMouseEvents
            >
                    {tutorialSteps.map((step, index) => {
                    return <div key={step.i}>
                        {Math.abs(activeStep - index) <= 2
                                ? lgCarrousselFeeder(activeStep, tutorialSteps)
                                : null
                        }
                                </div>
                    }

                )}

</AutoPlaySwipeableViews>
            <MobileStepper
                steps={maxSteps}
                position="static"
                variant="text"
                activeStep={activeStep}
                nextButton={
                    <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
                        Next
                        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                    </Button>
                }
                backButton={
                    <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                        Back
                    </Button>
                }
            />
        </div>
    );
}

export default CarrouselMaterial;
*/









//========================================================================









/*
import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import MobileStepper from '@material-ui/core/MobileStepper';
import Button from '@material-ui/core/Button';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import CardMedia from '@material-ui/core/CardMedia';
import {Card, CardContent, Grid} from "@material-ui/core";


const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const tutorialSteps = [
    {
        label: 'San Francisco – Oakland Bay Bridge, United States',
        imgPath:
            'https://images.unsplash.com/photo-1537944434965-cf4679d1a598?auto=format&fit=crop&w=400&h=250&q=60',
    },
    {
        label: 'Bird',
        imgPath:
            'https://images.unsplash.com/photo-1538032746644-0212e812a9e7?auto=format&fit=crop&w=400&h=250&q=60',
    }
];

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        height: 300
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(1),
        backgroundColor: theme.palette.background.default,
    },
    img: {
        height: 255,
        display: 'block',
        maxWidth: 400,
        overflow: 'hidden',
        width: '100%',
    },
}));

function CarrouselMaterial() {
    const classes = useStyles();
    const theme = useTheme();
    const [activeStep, setActiveStep] = React.useState(0);
    const maxSteps = tutorialSteps.length;

    const handleNext = () => {
        setActiveStep(prevActiveStep => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep(prevActiveStep => prevActiveStep - 1);
    };

    const handleStepChange = step => {
        setActiveStep(step);
    };

    return (
        <div className={`my-5 ${classes.root}`}>
            <AutoPlaySwipeableViews
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={activeStep}
                onChangeIndex={handleStepChange}
                enableMouseEvents
            ><div>
                    <Grid container>
                        <Grid item md={4}>
                            <Card>
                                <CardContent className="p-0 m-0 bg-info">
                                    <iframe src="https://www.youtube.com/embed/CplwgrIjD3o" frameBorder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen/>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item md={4}>
                            <Card>
                                <CardContent className="p-0 m-0 bg-info">
                                    <iframe src="https://www.youtube.com/embed/CplwgrIjD3o" frameBorder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen/>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item md={4}>
                            <Card>
                                <CardContent className="p-0 m-0 bg-info">
                                    <iframe src="https://www.youtube.com/embed/CplwgrIjD3o" frameBorder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen/>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item md={4}>
                            <Card>
                                <CardContent className="p-0 m-0 bg-info">
                                    <iframe src="https://www.youtube.com/embed/CplwgrIjD3o" frameBorder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen/>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item md={4}>
                            <Card>
                                <CardContent className="p-0 m-0 bg-info">
                                    <iframe src="https://www.youtube.com/embed/CplwgrIjD3o" frameBorder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen/>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </div>
            </AutoPlaySwipeableViews>
            <MobileStepper
                steps={maxSteps}
                position="static"
                variant="text"
                activeStep={activeStep}
                nextButton={
                    <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
                        Next
                        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                    </Button>
                }
                backButton={
                    <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                        Back
                    </Button>
                }
            />
        </div>
    );
}

export default CarrouselMaterial;

 */